import React from 'react';
import styles from './Tab.Content.scss';
export var TabContent = function TabContent(props) {
  return React.createElement("section", {
    role: "tabpanel",
    "data-test": "tab-content-".concat(props.dataTest),
    className: styles.tabContentArea
  }, props.active && props.children);
};